import { Button } from "flowbite-react";
import React from "react";
import { useNavigate } from "react-router";
import Lady from "../img/img-1.png";

function PreFooter() {
  const navigate = useNavigate();
  return (
    <section className="relative text-center bg-[url('./img/banner-2.jpg')] bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center space-y-8 py-14 px-4">
      <img
        alt=""
        src={Lady}
        className="absolute hidden lg:block lg:h-[360px] xl:h-[400px] bottom-0 lg:right-[0.8%] xl:right-[5%]"
      />
        <h3 className="text-2xl font-semibold text-[#244565]">Your Trusted Financing Partners, One For All</h3>
        <p className="px-4 lg:max-w-[50%] leading-tight text-slate-700 text-xl">To ensure that every client, has access to quality and independent advice to maximize their chances of success.</p>
        <Button
          className="!bg-[#244565] min-w-[200px] mb-10 hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
          onClick={() => navigate("/contactus")}
        >
          Contact us
        </Button>
    </section>
  );
}

export default PreFooter;
